import type {
  GetMaintenanceTypes,
  MaintenanceTypes,
} from "@/redux/maintenance/maintenanceTypes";

export const initialState: MaintenanceTypes = {
  maintenanceData: {} as GetMaintenanceTypes,
  isMaintenance: 0,
  success: null,
  error: null,
  statusCode: null,
  message: null,
};
